module.exports = new __parcel__URL__("the-matrix.44ffb4da.jpg").toString();